const ENDPOINTS = {
  SALES_SUMMARY: '/sales_summary',
  SALES_CHART: '/sales_chart',
  INVENTORY_LOCATIONS_SUMMARY: '/inventory_locations_summary',
  INVENTORY_LOCATIONS_CHART: '/inventory_locations_chart',
};

export default ENDPOINTS;
